export default {
  slug: "compose-multiplatform",
  code: "CMP",
  label: "Compose Multiplatform",
  isKED: true,
  hasSubtitle2: true,
  logoFamily: "jb",
};
